// extracted by mini-css-extract-plugin
module.exports = {"banner":"_025a50318d--banner--3LUWN","banner-image":"_025a50318d--banner-image--1-rN-"};